import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight, Clock } from "lucide-react";
import { scrollToId, ease } from "./constants";
import { Reveal, Eyebrow } from "./Reveal";

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="sobre" ref={ref} className="relative overflow-hidden bg-[#FACC15] py-24 text-[#0c0a09] sm:py-32" data-testid="about-section">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-5 sm:px-8 lg:grid-cols-12 lg:gap-16">
        <motion.div initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.1 }} className="lg:col-span-6">
          <motion.div variants={{ hidden: { clipPath: "inset(100% 0 0 0)" }, show: { clipPath: "inset(0% 0 0 0)" } }} transition={{ duration: 1.3, ease }} className="relative aspect-[4/5] overflow-hidden border-4 border-[#0c0a09] shadow-[16px_16px_0_0_#0c0a09]">
            <motion.img style={{ y, scale: 1.18 }} src="/img/about.jpg" alt="Camadas de compensado" className="h-full w-full object-cover" />
          </motion.div>
        </motion.div>
        <div className="lg:col-span-6">
          <Reveal><Eyebrow dark>Sobre nós</Eyebrow></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display mt-5 text-5xl font-black uppercase leading-[0.88] sm:text-6xl lg:text-7xl">
              Destak<br />
              <span className="bg-[#0c0a09] px-3 text-[#FACC15] [box-decoration-break:clone]">Compensados</span><br />
              e madeiras
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-8 text-base leading-relaxed text-stone-900 sm:text-lg">
              Somos uma empresa especializada na comercialização de compensados e madeiras, oferecendo produtos de qualidade e preços competitivos para clientes em Manaus.
            </p>
            <p className="mt-4 text-base leading-relaxed text-stone-900 sm:text-lg">
              Nosso objetivo é oferecer atendimento rápido, confiança e as melhores soluções para cada projeto.
            </p>
          </Reveal>
          <Reveal delay={0.25} className="mt-8 flex items-start gap-3 border-l-4 border-[#0c0a09] pl-4" >
            <Clock className="mt-0.5 h-5 w-5 shrink-0" />
            <p className="text-sm font-semibold" data-testid="about-hours">Seg. a Sex. das 08:00 às 17:00, sem fechar para almoço · Feriados das 08:00 às 12:00</p>
          </Reveal>
          <Reveal delay={0.3}>
            <button onClick={() => scrollToId("produtos")} data-testid="about-produtos-btn" className="btn-dark btn-lg mt-10">
              Conheça nossos produtos <ArrowRight className="h-5 w-5" />
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
